import { getKeyboardFocusableElementsIn } from "@smartsheet/lodestar-utils";

// This is a bit naive, but it will honestly work for quite a while.
// if this Menu component is ever used for LONG lists of stuff, we might want to
// introduce more of a LinkedHashMap kind of structure.
function getIt<T>(arr: T[], search: T, delta: number): T | null {
    for (let index = 0; index < arr.length; index++) {
        const current = arr[index];
        if (current === search) {
            const nextIndex = index + delta;
            if (nextIndex < 0 || nextIndex >= arr.length) {
                break;
            }
            return arr[nextIndex];
        }
    }
    return null;
}

export class FocusDelegate {
    private focusables: HTMLElement[] = [];

    public setFocusables(withinElement: HTMLElement): void {
        this.focusables = getKeyboardFocusableElementsIn(withinElement);
    }

    public addPortalFocusables(portalId: string, afterElem?: HTMLElement): void {
        const portal = document.getElementById(portalId);

        if (portal) {
            const focusablesFromPortal = getKeyboardFocusableElementsIn(portal);

            // Adds the new focusables after a secified element
            if (afterElem) {
                const afterElemIndex = this.focusables.indexOf(afterElem);

                // put the new focusables after the afterElem
                this.focusables = this.focusables
                    .slice(0, afterElemIndex + 1)
                    .concat(focusablesFromPortal)
                    .concat(this.focusables.slice(afterElemIndex + 1));
            } else {
                this.focusables = this.focusables.concat(focusablesFromPortal);
            }
        }
    }

    /** Returns the element visually above the given one, or `null` for none. */
    public getElementAbove(element: HTMLElement): HTMLElement | null {
        return getIt(this.focusables, element, -1);
    }

    /** Returns the element visually below the given one, or `null` for none. */
    public getElementBelow(element: HTMLElement): HTMLElement | null {
        return getIt(this.focusables, element, 1);
    }

    /** Returns the first element, or `null` for none. */
    public getFirstElement(): HTMLElement | null {
        return this.focusables[0] || null;
    }

    /** Returns the last element, or `null` for none. */
    public getLastElement(): HTMLElement | null {
        return this.focusables[this.focusables.length - 1] || null;
    }

    public getFirstEnabledElement(): HTMLElement | null {
        return (
            this.focusables.find((element) => {
                return (
                    (!element.ariaDisabled || element.ariaDisabled === "false") &&
                    !(element as HTMLInputElement).disabled
                );
            }) || null
        );
    }

    public focusablesInclude(elem: HTMLElement): boolean {
        return this.focusables.includes(elem);
    }
}
